export * from './vehicleModule';
